<script setup="">
import { throttle } from "lodash-es";
import { onBeforeMount, onBeforeUnmount } from "vue";

import { useResponsiveStore } from "@/stores/responsive";

const responsive = useResponsiveStore();

const states = {
  height: 0,
  width: 0,
  name: "",
  isChanged: false,
  isXs: false,
  isSm: false,
  isMd: false,
  isLg: false,
  isXl: false,
  is2xl: false,

  smAndDown: false,
  smAndUp: false,
  mdAndDown: false,
  mdAndUp: false,
  lgAndDown: false,
  lgAndUp: false,
  xlAndDown: false,
  xlAndUp: false,

  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  the2xl: 1536
};

const update = () => {
  const height = window.innerHeight;
  const width = window.innerWidth;

  const xs = width < states.sm;
  const sm = width < states.md && !xs;
  const md = width < states.lg && !(sm || xs);
  const lg = width < states.xl && !(md || sm || xs);
  const xl = width < states.the2xl && !(lg || md || sm || xs);
  const the2xl = width >= states.the2xl;

  states.height = height;
  states.width = width;

  states.isXs = xs;
  states.isSm = sm;
  states.isMd = md;
  states.isLg = lg;
  states.isXl = xl;
  states.is2xl = the2xl;

  states.smAndDown = (xs || sm) && !(md || lg || xl || the2xl);
  states.smAndUp = !xs && (sm || md || lg || xl || the2xl);
  states.mdAndDown = (xs || sm || md) && !(lg || xl || the2xl);
  states.mdAndUp = !(xs || sm) && (md || lg || xl || the2xl);
  states.lgAndDown = (xs || sm || md || lg) && !(xl || the2xl);
  states.lgAndUp = !(xs || sm || md) && (lg || xl || the2xl);
  states.xlAndDown = (xs || sm || md || lg || xl) && !the2xl;
  states.xlAndUp = !(xs || sm || md || lg) && (xl || the2xl);

  if (xs) states.name = "xs";
  if (sm) states.name = "sm";
  if (md) states.name = "md";
  if (lg) states.name = "lg";
  if (xl) states.name = "xl";
  if (the2xl) states.name = "2xl";

  // document.documentElement.style.setProperty("--vh", `${height * 0.01}px`);
  responsive.setStates(states);
};

const throttledUpdate = throttle(() => update(), 250);

onBeforeMount(() => {
  update();

  window.addEventListener("resize", throttledUpdate, {
    passive: true
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", throttledUpdate);
});
</script>

<template><span></span></template>
